(function () {
  function openPopup(popup) {
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closePopup(popup) {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    var video = popup.querySelector('video');
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-mct-vpop-trigger]');
    if (trigger) {
      e.preventDefault();
      var targetId = trigger.getAttribute('data-mct-vpop-trigger');
      var popup = document.getElementById(targetId);
      if (popup) openPopup(popup);
      return;
    }

    var closeBtn = e.target.closest('[data-mct-vpop-close]');
    if (closeBtn) {
      var openPopupEl = closeBtn.closest('[data-mct-vpop]');
      if (openPopupEl) closePopup(openPopupEl);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-mct-vpop].is-open').forEach(closePopup);
    }
  });
})();